import { render, staticRenderFns } from "./pendingValidationOrderslist.vue?vue&type=template&id=4bda8550&"
import script from "./pendingValidationOrderslist.vue?vue&type=script&lang=js&"
export * from "./pendingValidationOrderslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports